/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  dashboardService,
  type DashboardAnalyticsParams,
  type DashboardAnalyticsResponse,
} from "@src/@api-services/dashboard";

interface AnalyticsDashboardState {
  data: DashboardAnalyticsResponse | null;
  params: DashboardAnalyticsParams;
  loading: boolean;
  error: string | null;
}

export const getAnalyticsDashboard = createAsyncThunk(
  "analyticsDashboard/getAnalyticsDashboard",
  async (params: DashboardAnalyticsParams, { rejectWithValue }) => {
    try {
      const response = await dashboardService.getAnalytics(params);
      return {
        params,
        data: response.data?.data as DashboardAnalyticsResponse,
      };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch dashboard analytics"
      );
    }
  }
);

const initialState: AnalyticsDashboardState = {
  data: null,
  params: {
    periodType: "monthly",
    role: "all",
  },
  loading: false,
  error: null,
};

export const analyticsDashboardSlice = createSlice({
  name: "analyticsDashboard",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAnalyticsDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalyticsDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.params = action.payload.params;
      })
      .addCase(getAnalyticsDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.data = null;
      });
  },
});

export const { clearError } = analyticsDashboardSlice.actions;
export default analyticsDashboardSlice.reducer;
